
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  SupplierRseAnswersIndex.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SupplierRseAnswersIndex.ts

export class SupplierRseAnswersIndex {

  // int Id
  public Id: number=0;

  // int AnswerId
  public AnswerId: number=0;

  // int IndexId
  public IndexId: number=0;

  // string Value
  public Value?: string=null;
}